import { ApiAccountSnapshot, ApiOperationBase } from 'api/rtk-api'
import { Table } from 'components/core-v2'

import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'

interface IExternalTransfer {
  associatedInstruction: {
    shares: { assetId: string; shares: number }[]
  }
  generatedDate: string
  state: string
}

interface Props {
  operation: ApiOperationBase
  snapshot: ApiAccountSnapshot
}
export const ExternalTransferTable = ({ operation, snapshot }: Props) => {
  const {
    associatedInstruction: { shares }
  } = operation as unknown as IExternalTransfer

  const allAssets = [...snapshot.growthAssets, ...snapshot.protectedAssets]

  const rowData = shares.map(share => ({
    ...share,
    assetName: allAssets.find(asset => share.assetId === asset.assetId)?.assetName || '–'
  }))

  return (
    <Table
      showGreyHeader
      agGridProps={{
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44
      }}
      height="400px"
    />
  )
}
